import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Logo from "../../logo.png";
import MDL_CONFIRMATION from "../../components/cmp-confirmation/cmp-confirmation";
import MDL_UPDATE_PASSWORD from "../../components/mdl-update-password/mdl-scheduler-update-password";
import MDL_PROGRESS from "../cmp-progress/cmp-progress";
import "./Header.css";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Icon,
  Modal,
  Search,
  Label,
} from "semantic-ui-react";
import { AppContext } from "../../Context/AppContext";
import {
  buildingStat,
  getBuildingLookup,
  getSpecificUSer,
  getSingleBuilding,
} from "../../constants";
import RequestOrderIcon from "./RequestOrderIcon";
import MDL_UPDATE_SCHEDULER from "../../containers/admin/scheduler-management/mdl-update-scheduler/mdl-update-scheduler";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useParams } from "react-router-dom";

function Header({ user, setUser, building_info, setBuildingInfo, navToggle }) {
  /* VARIABLE DECLARATIONS
	---------------------------------------------------------------------------------*/
  const {
    orderCunt,
    selectedBuilding,
    sliderCart,
    cartItems,
    checkedUnitsData,
    selected_units,
    ShowHeaderSearch,
    BuildingUpdate,
    defaultPane,
    OrderTabStatus,
    orderFilter,
    sbuildingData,
    isUserImpersonated,
    appVersion,
    isAppVersionOutdated,
    locationId,
    buildingUnits,
    impersonator,
  } = useContext(AppContext);
  const [var_app_version] = appVersion;
  const [, setLocationId] = locationId;
  const [, setBuildingUnits] = buildingUnits;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const [, setOrderCount] = orderCunt;
  const [, setSideSliderCart] = sliderCart;
  const [cart_items, setCartItems] = cartItems;
  const [, setCheckedUnits] = checkedUnitsData;
  const [impersonated, setImpersonated] = isUserImpersonated;
  const [, set_add_unit] = selected_units;
  const [request_btn_hover, set_request_btn_hover] = useState("red");
  const [selected_building, setSelectedBuilding] = selectedBuilding;
  const [, setSingleBuildingData] = sbuildingData;
  const [var_mdl_confirmation, set_mdl_confirmation] = useState(false);
  const [mdl_update_password_open, set_mdl_update_password_open] =
    useState(false);
  const [mdl_update_profile_open, set_mdl_update_profile_open] =
    useState(false);
  const [var_scheduler_data, set_scheduler_data] = useState();
  const history = useHistory();
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ShowCart, setShowCart] = useState(false);
  const [query, setQuery] = useState("");
  const timeoutRef = React.useRef();
  const [, set_default_pane] = defaultPane;
  const [orderStatus, setOrderStatus] = OrderTabStatus;
  const [, set_order_filter] = orderFilter;
  const [, setBuildingUpdate] = BuildingUpdate;
  const [var_ShowHeaderSearch, setShowHeaderSearch] = ShowHeaderSearch;
  const [cartItemCount, setCartItemCount] = useState(0);
  const location = useLocation();
  const rawFrom = location?.state?.from;
  const isImpersonating = localStorage.getItem("impersonation") === "true";
  const from = typeof rawFrom === "string" ? rawFrom : rawFrom?.pathname || "";
  const [var_mdl_progress, set_mdl_progress] = useState(false);
  const [, setImpersonatorID] = impersonator;
  const abortControllerRef = useRef(null);
  const requestIdRef = useRef(0);
  const params = useParams();

  /* EVENT FUNCTIONS
	---------------------------------------------------------------------------------*/
  function onOpen_mdl_update_password() {
    set_mdl_update_password_open(true);
  }

  function onOpen_mdl_update_profile() {
    set_mdl_update_profile_open(true);
  }

  function getCumulativeLength(data) {
    if (data === null) return 0;
    return Object.values(data).reduce((total, arr) => {
      return total + (Array.isArray(arr) ? arr.length : 0);
    }, 0);
  }

  useState(() => {
    const { role } = user;
    if (role && role === "customer") getBuildingStat();
  }, [building_info]);

  const handleSearchChange = React.useCallback((e, data) => {
    if (!data.value?.trim()) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
        abortControllerRef.current = null;
      }
      setSearchResults([]);
    }
    setQuery(data.value);
  }, []);

  const resetBuildingState = () => {
    set_default_pane(0);
    setCartItems(null);
    setSideSliderCart(false);
    setCheckedUnits({});
    set_add_unit([{ unit_number: "", followup: false, key: 0 }]);
    localStorage.removeItem("building");
  };

  const setNewBuildingData = (buildingData) => {
    const customerUser = {
      role: "customer",
      uuid: buildingData?.uuid,
      firstName: buildingData?.building_name,
    };

    setUser(customerUser);
    localStorage.setItem("user", JSON.stringify(customerUser));

    const building = [
      {
        value: buildingData?.uuid,
        text: buildingData?.building_name,
        building_po_mo_wo: buildingData?.building_po_mo_wo,
        customer_name: buildingData?.customer_name,
        location_id: buildingData?.location_id,
      },
    ];
    localStorage.setItem("s_id", building[0].value);
    localStorage.setItem("building", JSON.stringify(building));
    setBuildingInfo(building);
  };

  /* EVENT LISTENERS
	---------------------------------------------------------------------------------*/
  useEffect(() => {
    setCartItemCount(getCumulativeLength(cart_items));
  }, [cart_items]);

  useEffect(() => {});

  useEffect(() => {
    if (!query) return;

    timeoutRef.current = setTimeout(() => {
      fetchBuildingInfo(query);
    }, 400);

    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [query]);

  useEffect(() => {
    async function getSchedulerData() {
      const requestHeaders = {
        headers: {
          entityid: user.uuid,
          appversion: var_app_version,
        },
      };
      try {
        //set_mdl_progress(true);
        const response = await fetch(
          getSpecificUSer + user.uuid,
          requestHeaders,
        );
        const res = await response.json();
        // Check app version
        if (
          res?.version &&
          res?.version !== var_app_version &&
          res.code !== 200
        ) {
          set_is_app_version_outdated(true);
        }
        const { id, fName, lName, email, associated_emails } = res.data[0];
        set_scheduler_data({
          uid: id,
          first_name: fName,
          last_name: lName,
          email,
          associated_emails,
        });
      } catch (error) {
        console.error("Error fetching schedulers:", error);
      }
      //set_mdl_progress(false);
    }
    if (mdl_update_profile_open) {
      getSchedulerData();
    }
  }, [mdl_update_profile_open]);

  useEffect(() => {
    const unlisten = history.listen((location) => {
      // This will be called every time the route changes
      if (location.pathname.includes("building-history/")) {
        setShowCart(true);
      } else {
        setShowCart(false);
      }
      // Trigger any state updates or effects as needed
    });
    return () => {
      unlisten(); // Cleanup the listener on unmount
    };
  }, [history]);

  /* ASYNC FUNCTIONS
	---------------------------------------------------------------------------------*/
  /**
   *
   */

  async function fetchBuildingInfo(searchQuery) {
    const requestId = ++requestIdRef.current;
    setIsLoading(true);
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    try {
      const response = await fetch(getBuildingLookup + `?q=${searchQuery}`, {
        signal: abortControllerRef.current.signal,
        headers: {
          entityid: user.uuid,
          appversion: var_app_version,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch building info");
      }
      const data = await response.json();
      // Only latest request can update state
      if (requestId !== requestIdRef.current) return;

      if (data.code === 200) {
        const updatedData = data.data.map((building) => ({
          ...building,
          title: `${building.text} - ${building?.customer_name} - ${building.location_number}`,
        }));
        setSearchResults(updatedData);
      } else {
        // Check app version
        if (data?.version && data?.version !== var_app_version) {
          set_is_app_version_outdated(true);
        }
      }
    } catch (error) {
      if (error.name === "AbortError") return;
      console.error("Error fetching building info:", error);
    } finally {
      // Only latest request can disable loader
      if (requestId === requestIdRef.current) {
        setIsLoading(false);
      }
    }
  }

  /**
   * Get the stats of building
   */
  async function getBuildingStat() {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };
    if (building_info && building_info.uuid) {
      await fetch(buildingStat + `${building_info.uuid}`, requestHeaders)
        .then((response) => response.json())
        .then((res) => {
          if (res.code === 200) {
            setOrderCount(res);
          } else {
            // Check app version
            if (res?.version && res?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      setBuildingInfo(null);
    }
  }
  /**
   * this function will switch the building when user search for building in
   * header search and select the building from dropdown result
   * 1. get the building details of selected building
   * 2. reset the context and local storage of previous building
   */
  async function switchBuilding(e, data) {
    set_mdl_progress(true);
    const buildingData = await getBuildingUnits(data.result.value);
    resetBuildingState();
    setNewBuildingData(buildingData);
    setSearchResults([]);
    setQuery("");
    set_mdl_progress(false);
  }

  async function getBuildingUnits(building_id) {
    const requestHeaders = {
      headers: {
        entityid: user.uuid,
        appversion: var_app_version,
      },
    };

    const res = await fetch(
      `${getSingleBuilding}${building_id}`,
      requestHeaders,
    );
    const response = await res.json();
    if (response.code !== 200) {
      if (response?.version && response?.version !== var_app_version) {
        set_is_app_version_outdated(true);
      }
    }
    const final_data = response.data[0];
    setSelectedBuilding(final_data);
    setLocationId(final_data?.location_id);
    setSingleBuildingData(final_data);
    setBuildingUnits(final_data?.units || []);
    return final_data;
  }

  const getInitials = function (string) {
    if (string) {
      var names = string.split(" "),
        initials = names[0].substring(0, 1).toUpperCase();

      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      return initials;
    } else {
      return "";
    }
  };

  function handleClick() {
    // if (cart_items) {
    setSideSliderCart(true);
    // } else {
    //   set_add_unit([{ unit_number: "", followup: "neworder", key: 0 }]);
    //   history.push(`/order-request/${selected_building?.location_id}`);
    // }
  }

  async function doSearch(event) {
    const value = event.target.value.toString().toLowerCase();
  }

  function resultSelect(e, data) {
    set_default_pane(0);
    history.push(`/building-impersonate/${data.result.value}`);
    setSearchResults([]);
    setQuery("");
  }

  function onChangeBuilding(event, { value }) {
    setSelectedBuilding(building_info.filter((f_v) => f_v.value === value)[0]);
    setBuildingUpdate(true);
    setCartItems(null);
    setCheckedUnits({});
    set_add_unit([{ unit_number: "", followup: false, key: 0 }]);
  }

  const goBackToScheduler = () => {
    const scheduler = JSON.parse(localStorage.getItem("scheduler_user"));
    if (scheduler) {
      setUser(scheduler);
      set_default_pane(0);
      setCartItems(null);
      setSideSliderCart(false);
      setCheckedUnits({});
      set_add_unit([{ unit_number: "", followup: false, key: 0 }]);
      localStorage.setItem("user", JSON.stringify(scheduler));
      localStorage.removeItem("impersonation");
      localStorage.removeItem("building");
      history.replace(`/scheduler-home`);
    }
  };

  /* RENDER APP
	---------------------------------------------------------------------------------*/
  return user ? (
    user.role === "customer" && building_info?.length === 0 ? null : (
      <>
        <header className="app-header">
          <div className="app-container">
            <div className="app-header-inner">
              <div className="app-header-logo">
                <Link
                  to={
                    !isImpersonating
                      ? user.role === "customer"
                        ? `/home?s_id=${localStorage.getItem("s_id")}`
                        : user.role === "technician"
                          ? "/technician-home"
                          : user.role === "admin"
                            ? "/dashboard"
                            : "/scheduler-home"
                      : ""
                  }
                  onClick={(e) => {
                    if (user.role === "customer" && isImpersonating) {
                      e.preventDefault();
                      goBackToScheduler();
                    } else if (user.role === "customer") {
                      e.preventDefault();
                      set_add_unit([
                        { unit_number: "", followup: false, key: 0 },
                      ]);
                      history.push(
                        `/home?s_id=${localStorage.getItem("s_id")}`,
                      );
                    } else if (user.role === "scheduler") {
                      set_default_pane(0);
                    }
                    setShowHeaderSearch(!var_ShowHeaderSearch);
                  }}
                >
                  <img src={Logo} alt={`${var_ShowHeaderSearch}PestPac`} />
                </Link>
                {user.role === "admin" && (
                  <div
                    className="mobile-nav-toggler"
                    onClick={() => navToggle()}
                  >
                    <img src="./hamburger.svg" alt="" />
                  </div>
                )}
                {building_info?.length > 0 &&
                  location?.pathname === "/home" &&
                  !isImpersonating && (
                    <Dropdown
                      search
                      style={{ width: "290px" }}
                      selection
                      // className="sortby_options"
                      id="sortby_optionss"
                      // name="sortby_options"
                      // input={<OutlinedInput label="Tag" />}
                      placeholder="Select Building"
                      label="Building: "
                      name="building"
                      onChange={onChangeBuilding}
                      value={selected_building?.value}
                      options={building_info}
                    />
                  )}
                {user.role === "scheduler" &&
                  !history.location.pathname.includes("/notes") &&
                  !history.location.pathname.includes("/building-heatmap") &&
                  !(
                    from?.includes("/building-impersonate") &&
                    history.location.pathname.includes("/scheduler-order-draft")
                  ) &&
                  !(
                    from?.includes("/building-impersonate") &&
                    history.location.pathname.includes(
                      "/scheduler-home/update-order",
                    )
                  ) &&
                  !(
                    from?.includes("/building-impersonate") &&
                    history.location.pathname.includes("/complete-order")
                  ) && (
                    <div className="app-content-search">
                      <Search
                        loading={isLoading}
                        onResultSelect={resultSelect}
                        results={searchResults}
                        value={query}
                        placeholder="Search Building or Location #"
                        onSearchChange={handleSearchChange}
                      />
                    </div>
                  )}
                {/* 
              This condition is for showing search in header when customer is
              impersonating  and in home page of customer after impersonation 
              */}

                {user.role === "customer" &&
                  isImpersonating &&
                  history.location.pathname === "/home" && (
                    <div className="app-content-search">
                      <Search
                        loading={isLoading}
                        onResultSelect={switchBuilding}
                        results={searchResults}
                        value={query}
                        placeholder="Search Building or Location #"
                        onSearchChange={handleSearchChange}
                      />
                    </div>
                  )}
              </div>
              <div className="app-header-content">
                <div className="app-header-user">
                  <div
                    className="loggedin-user"
                    style={{
                      marginTop: user.role === "scheduler" ? "14px" : "14px",
                    }}
                  >
                    {/* {user.role === "scheduler" && (
                    <>
                    <div
                      className="update-schulder-profile"
                      name="Update Profile"
                      onClick={() => onOpen_mdl_update_profile()}
                      
                    >
                      <img
                        src="./icon-user.png"
                        alt="Profile"
                        width={15}
                        height={15}
                      />
                      <span>Update Profile</span>
                    </div>
                    <div
                      className="update-pass"
                      name="Update Password"
                      onClick={() => onOpen_mdl_update_password()}
                      
                    >
                      <img
                        src="./icon-padlock.svg"
                        alt="Password"
                        width={15}
                        height={15}
                      />
                      <span>Update Password</span>
                    </div>
                    </>
                  )} */}

                    {user.role === "technician" && (
                      <div
                        className="update-pass"
                        name="Update Password"
                        onClick={() => onOpen_mdl_update_password()}
                      >
                        <img
                          src="./icon-padlock.svg"
                          alt="Password"
                          width={15}
                          height={15}
                        />
                        <span>Update Password</span>
                      </div>
                    )}
                    {/* {user.role !=='customer'&& <div className="loggedin-user-short">
                   
                     <div title={user.firstName + " " + user.lastName}>
                        {user.firstName && `${user.firstName[0]}`}{" "}
                        {user.lastName && `${user.lastName[0]}`}
                      </div>
                    
                  </div>} */}
                    {user.role !== "admin" &&
                      !isImpersonating &&
                      !impersonated && (
                        <Dropdown
                          style={{ marginRight: "10px", marginTop: "4px" }}
                          className="account-dropdown link item"
                          text={
                            <>
                              <Icon size="big" name="user circle" />
                              <span style={{ fontSize: "16px" }}>Account</span>
                            </>
                          }
                          floating
                        >
                          <DropdownMenu>
                            <DropdownItem>
                              {user.role === "customer" && (
                                <div
                                  className="requests-contain"
                                  name="Documents"
                                  onClick={() => history.push("/documents")}
                                >
                                  {/* <img
                              title="Documents"
                              src={`${window.location.origin}/folder-icon.png`}
                              alt="documents"
                            /> */}
                                  <Icon
                                    name="folder"
                                    color="grey"
                                    inverted
                                    size="big"
                                  />
                                  Documents
                                </div>
                              )}
                              {user.role === "scheduler" && (
                                <div
                                  className="update-schulder-profile"
                                  name="Update Profile"
                                  onClick={() => onOpen_mdl_update_profile()}
                                >
                                  <Icon
                                    size="big"
                                    color="grey"
                                    inverted
                                    name="id badge outline"
                                  />
                                  {/* <img
                            src="./icon-user.png"
                            alt="Profile"
                            width={15}
                            height={15}
                          /> */}
                                  <span>Profile</span>
                                </div>
                              )}
                            </DropdownItem>
                            <DropdownItem
                              style={{
                                paddingLeft: "0!important",
                                paddingRight: "0!important",
                              }}
                            >
                              <div
                                className="logout-content"
                                name="Logout"
                                onClick={() => set_mdl_confirmation(true)}
                              >
                                {/* <span className="logout-img">
                        <img src="./logout.svg" alt="Logout" />
                      </span> */}
                                <Icon
                                  size="big"
                                  color="grey"
                                  inverted
                                  name="log out"
                                />
                                <span style={{ fontSize: "14px" }}>Logout</span>
                              </div>
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      )}

                    {/* {user.role === "customer" && isImpersonating && (
                    <Label
                      basic
                      color="red"
                      size="large"
                      onClick={goBackToScheduler}
                      style={{ cursor: "pointer" }}
                      className="impersonation-exit-btn"
                    >
                      <Icon name="sign-out" />
                      Exit Impersonation
                    </Label>
                  )} */}
                    {user.role === "customer" &&
                      (history.location.pathname === "/home" ||
                        window.location.pathname.includes(
                          "building-history/",
                        ) ||
                        ShowCart) && (
                        <div
                          onMouseEnter={() => {
                            set_request_btn_hover("white");
                          }}
                          onMouseLeave={() => {
                            set_request_btn_hover("red");
                          }}
                          className="request-btn-div"
                        >
                          <Button
                            className="btn-request-header"
                            inverted
                            color={"red"}
                            onClick={() => handleClick()}
                          >
                            {cartItemCount > 0 && (
                              <Label
                                className="cart-count-label"
                                floating
                                circular
                                size="small"
                              >
                                {cartItemCount > 9 ? "9+" : cartItemCount}
                              </Label>
                            )}

                            <RequestOrderIcon fill={request_btn_hover} />
                            <span
                              style={{
                                padding: "0px 12px 0px 0px",
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                            >
                              Cart
                            </span>
                          </Button>
                        </div>
                      )}
                    {/* {user.role !== "admin" && user.role!=='customer' && (
                    <div
                      className="logout-content"
                      name="Logout"
                      onClick={() => set_mdl_confirmation(true)}
                    >
                      <span className="logout-img">
                        <img src="./logout.svg" alt="Logout" />
                      </span>
                      <span>Logout </span>
                      <Icon size="big" color='grey' inverted name="log out"/>
                    </div>
                  )} */}
                    {/* <div className="loggedin-username">
                                    {user.role==="customer"?"" : user.firstName+ " " +user.lastName }
                                </div> */}
                  </div>
                </div>
              </div>
            </div>
            {/***** MODAL: DELETE CONFIRMATION **************************************************************************/}
            <Modal
              id="mdl-confirmation"
              dimmer={"inverted"}
              open={var_mdl_confirmation}
              onClose={() => set_mdl_confirmation(false)}
            >
              <MDL_CONFIRMATION
                set_mdl_open={set_mdl_confirmation}
                var_modaltitle="Logout"
                var_message="Are you sure you want to log out?"
                confirmation_function={() => {
                  localStorage.removeItem("user");
                  localStorage.removeItem("building");
                  setSelectedBuilding(null);
                  setSingleBuildingData([]);
                  setCartItems(null);
                  setCheckedUnits({});
                  set_default_pane(0);
                  set_order_filter(3);
                  set_add_unit([{ unit_number: "", followup: false, key: 0 }]);
                  if (user.role === "customer") {
                    setBuildingInfo(null);
                    history.replace("/");
                    localStorage.clear();
                  } else if (user.role === "technician") {
                    history.replace("/technician");
                  } else {
                    history.replace("/scheduler");
                  }
                  setUser(null);
                }}
              ></MDL_CONFIRMATION>
            </Modal>

            {/***** MODAL: UPDATE PASSWORD - SCHEDULER **************************************************************************/}
            <Modal
              id="mdl-forgot-pin-customer"
              dimmer={"inverted"}
              open={mdl_update_password_open}
              onClose={() => set_mdl_update_password_open(false)}
            >
              <MDL_UPDATE_PASSWORD
                set_mdl_open={set_mdl_update_password_open}
              ></MDL_UPDATE_PASSWORD>
            </Modal>

            {/***** END MODAL: UPDATE PASSWORD - SCHEDULER **************************************************************************/}
            {/***** MODAL: UPDATE SCHEDULER **************************************************************************/}
            <Modal
              id="mdl-update-scheduler"
              style={{ overflow: "visible" }}
              dimmer={"inverted"}
              open={mdl_update_profile_open}
              onClose={() => {
                if (orderStatus === "followUp") {
                  setOrderStatus("followUp");
                  set_default_pane(2);
                } else if (orderStatus === "posted") {
                  setOrderStatus("posted");
                  set_default_pane(1);
                } else {
                  setOrderStatus("");
                  set_default_pane(0);
                }
                set_mdl_update_profile_open(false);
              }}
            >
              <MDL_UPDATE_SCHEDULER
                set_mdl_open={set_mdl_update_profile_open}
                scheduler={var_scheduler_data}
              ></MDL_UPDATE_SCHEDULER>
            </Modal>

            {/***** END MODAL: UPDATE SCHEDULER **************************************************************************/}
          </div>
        </header>

        {/***** MODAL: PROGRESS **************************************************************************/}
        <Modal
          id="mdl-progress"
          dimmer={"inverted"}
          open={var_mdl_progress}
          closeOnDimmerClick={false}
          closeOnEscape={false}
          onClose={() => {}}
        >
          <MDL_PROGRESS
            set_mdl_open={set_mdl_progress}
            var_modaltitle="Please wait"
            var_message={"Stay on this page until this process finish."}
          ></MDL_PROGRESS>
        </Modal>

        {/***** END MODAL: PROGRESS **************************************************************************/}
      </>
    )
  ) : null;
}

export default Header;
